import { StyleSheet } from 'react-native'
import Svg, {
  Defs,
  G,
  LinearGradient,
  Mask,
  Path,
  Rect,
  Stop,
} from 'react-native-svg'
import { colors } from '@ui/colors'

import { OVAL_PATH } from '../assets/ovalPath'
import {
  MASK_GRADIENT_OPACITY_BOTTOM,
  MASK_GRADIENT_OPACITY_TOP,
} from '../styles'
import { OvalLayout } from '../types'

type Props = {
  layout: OvalLayout
}

/**
 * Fullscreen dimming layer with the oval cut out, so only the camera
 * feed inside the oval stays visible. The dim is a vertical gradient.
 */
export default function OvalMask({ layout }: Props) {
  const { width, height, transform } = layout
  return (
    <Svg
      width={width}
      height={height}
      style={StyleSheet.absoluteFill}
      pointerEvents="none"
    >
      <Defs>
        <LinearGradient
          id="oval-mask-gradient"
          x1="0"
          y1="0"
          x2="0"
          y2={height}
          gradientUnits="userSpaceOnUse"
        >
          <Stop
            offset="0"
            stopColor={colors.black}
            stopOpacity={MASK_GRADIENT_OPACITY_TOP}
          />
          <Stop
            offset="1"
            stopColor={colors.black}
            stopOpacity={MASK_GRADIENT_OPACITY_BOTTOM}
          />
        </LinearGradient>
        <Mask
          id="oval-mask-hole"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width}
          height={height}
        >
          <Rect x="0" y="0" width={width} height={height} fill={colors.white} />
          <G transform={transform}>
            <Path d={OVAL_PATH} fill={colors.black} />
          </G>
        </Mask>
      </Defs>
      <Rect
        x="0"
        y="0"
        width={width}
        height={height}
        fill="url(#oval-mask-gradient)"
        mask="url(#oval-mask-hole)"
      />
    </Svg>
  )
}
